"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renders = exports.perPageOptions = exports.levels = exports.levelList = exports.getFlatColumnTree = exports.getColumnTree = exports.columnTypesMap = exports.columnTypes = exports.allRenders = exports.allColumns = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var appDefs = window.cccisd.appDefs;
var columnTypes = exports.columnTypes = [{
  value: 'number',
  label: 'Number'
}, {
  value: 'string',
  label: 'String'
}, {
  value: 'boolean',
  label: 'Boolean'
}];
var columnTypesMap = exports.columnTypesMap = function () {
  var result = {};
  for (var _i = 0, _columnTypes = columnTypes; _i < _columnTypes.length; _i++) {
    var type = _columnTypes[_i];
    result[type.value] = type;
  }
  return result;
}();
var levelList = exports.levelList = process.env.NODE_ENV !== 'test' ? [].concat(_toConsumableArray(appDefs.pawn.roles.length > 0 ? [{
  value: 'roles',
  label: 'Roles'
}] : []), _toConsumableArray(appDefs.pawn.groups.length > 0 ? [{
  value: 'groups',
  label: 'Groups'
}] : [])) : [];
var levels = exports.levels = {
  groups: {
    rows: (0, _get2["default"])(appDefs, 'pawn.groups', []).map(function (item) {
      return {
        value: item.handle,
        label: item.label
      };
    }),
    key: 'group.groupId',
    initialColumns: [{
      id: 1,
      name: 'group.groupId',
      query: 'group.groupId',
      label: 'Group ID',
      type: 'number',
      alignment: 'left',
      filter: true,
      sort: true
    }, {
      id: 2,
      name: 'group.label',
      query: 'group.label',
      label: 'Label',
      type: 'string',
      alignment: 'left',
      filter: true,
      sort: true
    }],
    tree: [{
      label: 'About group',
      children: ['group.groupId', 'group.label']
    }],
    ancestorKey: 'parentGroups'
  },
  roles: {
    rows: (0, _get2["default"])(appDefs, 'pawn.roles', []).map(function (item) {
      return {
        value: item.handle,
        label: item.label
      };
    }),
    key: 'pawn.pawnId',
    initialColumns: [{
      id: 1,
      name: 'pawn.pawnId',
      query: 'pawn.pawnId',
      label: 'System ID',
      type: 'number',
      alignment: 'left',
      filter: true,
      sort: true
    }],
    tree: [{
      label: 'About pawn',
      children: ['pawn.pawnId', 'pawn.createdDate']
    }],
    ancestorKey: 'membersOf'
  }
};
var allRenders = exports.allRenders = {
  bold: {
    value: 'bold',
    label: 'Bold',
    render: function render(_ref) {
      var value = _ref.value,
        row = _ref.row;
      return /*#__PURE__*/_react["default"].createElement("b", null, value);
    }
  },
  percent: {
    value: 'percent',
    label: 'Percent',
    render: function render(_ref2) {
      var value = _ref2.value,
        row = _ref2.row;
      return "".concat(value, "%");
    }
  }
};
var renders = exports.renders = {
  number: [allRenders.bold, allRenders.percent],
  string: [allRenders.bold],
  text: [allRenders.bold]
};
var perPageOptions = exports.perPageOptions = [{
  value: '10',
  label: '10'
}, {
  value: '20',
  label: '20'
}, {
  value: '50',
  label: '50'
}];
var allColumns = exports.allColumns = function () {
  if (process.env.NODE_ENV === 'test') {
    return {};
  }
  var columns = {
    'pawn.pawnId': {
      label: 'System ID',
      type: 'number'
    },
    'pawn.createdDate': {
      label: 'Created Date',
      type: 'string'
    },
    'group.groupId': {
      label: 'Group ID',
      type: 'number'
    },
    'group.label': {
      label: 'Label',
      type: 'string'
    },
    'user.username': {
      label: 'Username',
      type: 'string'
    },
    'user.firstName': {
      label: 'First Name',
      type: 'string'
    },
    'user.lastName': {
      label: 'Last Name',
      type: 'string'
    },
    'user.fullName': {
      label: 'Full Name',
      type: 'string'
    },
    'user.fullNameWithEmail': {
      label: 'Full Name with Email',
      type: 'string'
    },
    'user.fullNameWithUsername': {
      label: 'Full Name with Username',
      type: 'string'
    },
    'user.email': {
      label: 'Email',
      type: 'string'
    },
    'user.phone': {
      label: 'Phone',
      type: 'string'
    },
    'user.activated': {
      label: 'Activated',
      type: 'boolean'
    },
    'user.hasLoggedIn': {
      label: 'Has Logged In?',
      type: 'boolean'
    },
    'user.lastLoginDate': {
      label: 'Last Login Date',
      type: 'string'
    }
  };
  appDefs.pawn.fields.forEach(function (field) {
    columns["fields.".concat(field.handle)] = {
      label: field.label,
      type: field.data_type
    };
  });
  appDefs.pawn.groups.forEach(function (group) {
    columns["descendantGroups.".concat(group.handle, "Count")] = {
      label: "".concat(group.label, " count"),
      type: 'number'
    };
  });
  appDefs.pawn.roles.forEach(function (role) {
    columns["childRoles.".concat(role.handle, "Count")] = {
      label: "".concat(role.label, " count"),
      type: 'number'
    };
    columns["descendantRoles.".concat(role.handle, "Count")] = {
      label: "".concat(role.label, " count"),
      type: 'number'
    };
  });
  return columns;
}();
var getFields = function getFields() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var level = arguments.length > 1 ? arguments[1] : undefined;
  var rows = arguments.length > 2 ? arguments[2] : undefined;
  return appDefs.pawn[level].find(function (item) {
    return item.handle === rows;
  }).fields.map(function (name) {
    return _objectSpread({
      id: "".concat(prefix, "fields.").concat(name)
    }, allColumns["fields.".concat(name)]);
  });
};
var getFlatColumnTree = exports.getFlatColumnTree = function getFlatColumnTree(level, rows) {
  var result = {};
  var tree = getColumnTree(level, rows);
  function traverse(node) {
    node.forEach(function (item, index) {
      if (item.children) {
        traverse(item.children);
      } else {
        result[item.id] = item;
      }
    });
  }
  traverse(tree);
  return result;
};
var getColumnTree = exports.getColumnTree = function getColumnTree(level, rows) {
  var deployments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var tree = _toConsumableArray(levels[level].tree);

  // Get user information if it's a fortress user
  (function () {
    if (level !== 'roles') {
      return;
    }
    var info = appDefs.pawn[level].find(function (item) {
      return item.handle === rows;
    });
    if (info && info.isFortressUser) {
      tree.push({
        label: 'User info',
        children: ['user.username', 'user.firstName', 'user.lastName', 'user.fullName', 'user.fullNameWithEmail', 'user.fullNameWithUsername', 'user.email', 'user.phone', 'user.activated', 'user.hasLoggedIn', 'user.lastLoginDate']
      });
    }
  })();

  // Get fields
  tree.push({
    label: 'Fields',
    children: getFields('', level, rows)
  });

  // Get ancestors
  function getAncestors() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var level1 = arguments.length > 1 ? arguments[1] : undefined;
    var rows1 = arguments.length > 2 ? arguments[2] : undefined;
    var info = appDefs.pawn[level1].find(function (item) {
      return item.handle === rows1;
    });
    var key = levels[level1].ancestorKey;
    if (info && info[key] && info[key].length > 0) {
      var group = info[key][0];
      var groupInfo = appDefs.pawn.groups.find(function (item) {
        return item.handle === group;
      });
      if (groupInfo) {
        tree.push({
          label: groupInfo.label,
          children: [].concat(_toConsumableArray(['group.groupId', 'group.label'].map(function (name) {
            return _objectSpread(_objectSpread({}, allColumns[name]), {}, {
              id: "".concat(prefix, "ancestorGroups.").concat(group, ".").concat(name),
              label: "".concat(groupInfo.label, " ").concat(allColumns[name].label)
            });
          })), [{
            label: 'Fields',
            children: getFields("".concat(prefix, "ancestorGroups.").concat(group, "."), 'groups', group)
          }])
        });
        getAncestors("".concat(prefix, "ancestorGroups.").concat(group, "."), 'groups', group);
      }
    }
  }
  getAncestors('', level, rows);

  // Get descendant
  if (level === 'groups') {
    var childRoles = [];
    var childGroups = [];
    var _getDescendants = function getDescendants(rows1) {
      var info = appDefs.pawn[level].find(function (item) {
        return item.handle === rows1;
      });
      if (info && info.containsRoles) {
        childRoles.push.apply(childRoles, _toConsumableArray(info.containsRoles));
      }
      if (info && info.childGroups) {
        childGroups.push.apply(childGroups, _toConsumableArray(info.childGroups));
        info.childGroups.forEach(_getDescendants);
      }
    };
    _getDescendants(rows);
    if (childRoles.length > 0) {
      tree.push({
        label: 'Role Counts',
        children: childRoles.map(function (child) {
          return "descendantRoles.".concat(child, "Count");
        })
      });
    }
    if (childGroups.length > 0) {
      tree.push({
        label: 'Group Counts',
        children: childGroups.map(function (child) {
          return "descendantGroups.".concat(child, "Count");
        })
      });
    }
  }

  // Get child roles
  if (level === 'roles') {
    var info = appDefs.pawn[level].find(function (item) {
      return item.handle === rows;
    });
    if (info && info.childRoles && info.childRoles.length > 0) {
      tree.push({
        label: 'Role Counts',
        children: info.childRoles.map(function (child) {
          return "childRoles.".concat(child, "Count");
        })
      });
    }
  }

  // Get progress
  (function () {
    if (level !== 'roles' || deployments.length === 0) {
      return;
    }
    tree.push({
      label: 'Progress and Metrics',
      children: deployments
    });
  })();

  // Add sort information
  (function () {
    var sort = 1;
    function traverse(node) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      node.forEach(function (item, index) {
        if (typeof item === 'string') {
          node[index] = _objectSpread({
            id: item,
            sort: sort++
          }, allColumns[item]);
        } else if (item.children) {
          item.id = "".concat(prefix).concat(item.label);
          traverse(item.children, "".concat(prefix).concat(item.label, "."));
        } else {
          item.sort = sort++;
        }
      });
    }
    traverse(tree);
  })();
  return tree;
};